import { Box, Card, CardContent, Divider, Grid, Typography } from '@mui/material';

const SectionCard = ({ title, mapper, data }) => (
  <Card sx={{ mb: 3, borderRadius: 2 }}>
    <CardContent>
      <Typography fontWeight={600} mb={1}>
        {title}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={3}>
        {mapper?.map((e, i) => (
          <Grid item xs={12} sm={e?.fullWidth ? 12 : 6} key={i}>
            <Box>
              <Typography variant="caption" color="text.secondary">
                {e?.label}
              </Typography>
              <Typography fontWeight={500}>{data?.[e?.value] || '-'}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </CardContent>
  </Card>
);

export default SectionCard;
